import { Helmet } from 'react-helmet-async';
import TagManager from 'src/sections/overview/dashboards/views/tag-manager/view';

export default function SearchPerformanceClusterManager() {
  return (
    <>
      <Helmet>
        <title>Cluster Manager</title>
      </Helmet>

      <TagManager />
    </>
  );
}
